import { render } from "./SubTaskList.vue?vue&type=template&id=1fae2b6a&scoped=true"
import script from "./SubTaskList.vue?vue&type=script&lang=js"
export * from "./SubTaskList.vue?vue&type=script&lang=js"

import "./SubTaskList.vue?vue&type=style&index=0&id=1fae2b6a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fae2b6a"]])

export default __exports__